class CustomTemplate {
  constructor(
    emailTemplateEnabled,
    emailTemplateTriggeredSubject,
    emailTemplateTriggeredBody,
    emailTemplateClearedSubject,
    emailTemplateClearedBody,
    smsTemplateEnabled,
    smsTemplateTriggeredBody,
    smsTemplateClearedBody,
  ) {
    this.emailTemplateEnabled = emailTemplateEnabled;
    this.emailTemplateTriggeredSubject = emailTemplateTriggeredSubject;
    this.emailTemplateTriggeredBody = emailTemplateTriggeredBody;
    this.emailTemplateClearedSubject = emailTemplateClearedSubject;
    this.emailTemplateClearedBody = emailTemplateClearedBody;
    this.smsTemplateEnabled = smsTemplateEnabled;
    this.smsTemplateTriggeredBody = smsTemplateTriggeredBody;
    this.smsTemplateClearedBody = smsTemplateClearedBody;
  }
}
export default CustomTemplate;
